import React, { useState } from "react";
import "./Donation.css";

const PRESET_AMOUNTS = [10, 25, 50, 100, 250, 500];

const Donation = () => {
    const [amount, setAmount] = useState(25);
    const [customAmount, setCustomAmount] = useState("");

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const [anonymous, setAnonymous] = useState(false);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const getDonationAmount = () => {
        if (amount === "custom") {
            return Number(customAmount);
        }

        return Number(amount);
    };

    const handlePresetAmount = (value) => {
        setAmount(value);
        setCustomAmount("");
        setError("");
    };

    const handleCustomAmount = () => {
        setAmount("custom");
        setError("");
    };

    const handleDonate = async (event) => {
        event.preventDefault();

        setError("");

        const donationAmount = getDonationAmount();

        if (!donationAmount || donationAmount < 1) {
            setError(
                "Please enter a donation amount of at least $1."
            );
            return;
        }

        if (donationAmount > 100000) {
            setError(
                "The maximum donation amount is $100,000."
            );
            return;
        }

        if (!email.trim()) {
            setError(
                "Please enter your email address."
            );
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(
                "/api/donations/create-checkout-session",
                {
                    method: "POST",

                    headers: {
                        "Content-Type": "application/json",
                    },

                    credentials: "include",

                    body: JSON.stringify({
                        amount: donationAmount,
                        name: anonymous ? "" : name.trim(),
                        email: email.trim(),
                        message: message.trim(),
                        anonymous: anonymous,
                    }),
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(
                    data.error ||
                    "Unable to start the donation."
                );
            }

            if (!data.checkout_url) {
                throw new Error(
                    "Stripe Checkout URL was not returned."
                );
            }

            /*
             * Redirect the donor to Stripe Checkout.
             */
            window.location.href = data.checkout_url;

        } catch (err) {
            console.error(
                "Donation error:",
                err
            );

            setError(
                err.message ||
                "Something went wrong. Please try again."
            );

            setLoading(false);
        }
    };

    return (
        <main className="donation-page">

            {/* =====================================================
                HERO
            ====================================================== */}

            <section className="donation-hero">

                <div className="donation-hero-overlay"></div>

                <div className="donation-hero-content">

                    <div className="donation-eyebrow">
                        SUPPORT STEMX365
                    </div>

                    <h1>
                        Help Build the Next
                        <span>
                            Generation of Space Engineers
                        </span>
                    </h1>

                    <p>
                        Your support helps students gain access
                        to STEM education, robotics, space science,
                        and real-world space technology programs.
                    </p>

                </div>

            </section>


            {/* =====================================================
                DONATION SECTION
            ====================================================== */}

            <section className="donation-section">

                <div className="donation-container">

                    {/* LEFT CONTENT */}

                    <div className="donation-information">

                        <div className="donation-eyebrow">
                            MAKE AN IMPACT
                        </div>

                        <h2>
                            Your Support Creates Opportunity
                        </h2>

                        <p>
                            Space is becoming one of the most
                            important frontiers for science,
                            technology, and human innovation.
                        </p>

                        <p>
                            STEMX365 works to provide students
                            with opportunities to learn, build,
                            experiment, and participate in
                            programs connected to the
                            international space community.
                        </p>

                        <p>
                            Your contribution helps us create
                            educational opportunities for students
                            who may otherwise not have access to
                            these experiences.
                        </p>


                        {/* IMPACT GRID */}

                        <div className="impact-grid">

                            <div className="impact-card">

                                <div className="impact-icon">
                                    🚀
                                </div>

                                <h3>
                                    Space Education
                                </h3>

                                <p>
                                    Hands-on learning connected
                                    to real-world space missions
                                    and technology.
                                </p>

                            </div>


                            <div className="impact-card">

                                <div className="impact-icon">
                                    🤖
                                </div>

                                <h3>
                                    Robotics
                                </h3>

                                <p>
                                    Programming and robotics
                                    challenges that develop
                                    practical engineering skills.
                                </p>

                            </div>


                            <div className="impact-card">

                                <div className="impact-icon">
                                    🔬
                                </div>

                                <h3>
                                    STEM Research
                                </h3>

                                <p>
                                    Opportunities for students
                                    to explore science and
                                    engineering.
                                </p>

                            </div>


                            <div className="impact-card">

                                <div className="impact-icon">
                                    👩‍🚀
                                </div>

                                <h3>
                                    Space Workforce
                                </h3>

                                <p>
                                    Preparing students for the
                                    rapidly developing global
                                    space economy.
                                </p>

                            </div>

                        </div>

                    </div>


                    {/* =================================================
                        DONATION FORM
                    ================================================== */}

                    <div className="donation-card">

                        <div className="donation-card-header">

                            <h2>
                                Make a Donation
                            </h2>

                            <p>
                                Every contribution makes a difference.
                            </p>

                        </div>


                        <form onSubmit={handleDonate}>

                            {/* AMOUNT */}

                            <div className="form-section">

                                <label className="form-label">
                                    Choose your contribution
                                </label>

                                <div className="amount-grid">

                                    {PRESET_AMOUNTS.map(
                                        (value) => (

                                            <button
                                                key={value}
                                                type="button"
                                                className={
                                                    amount === value
                                                        ? "amount-button selected"
                                                        : "amount-button"
                                                }
                                                onClick={() =>
                                                    handlePresetAmount(
                                                        value
                                                    )
                                                }
                                            >
                                                ${value}
                                            </button>

                                        )
                                    )}

                                    <button
                                        type="button"
                                        className={
                                            amount === "custom"
                                                ? "amount-button selected"
                                                : "amount-button"
                                        }
                                        onClick={
                                            handleCustomAmount
                                        }
                                    >
                                        Other
                                    </button>

                                </div>

                            </div>


                            {/* CUSTOM AMOUNT */}

                            {amount === "custom" && (

                                <div className="form-section">

                                    <label
                                        className="form-label"
                                        htmlFor="customAmount"
                                    >
                                        Donation amount
                                    </label>

                                    <div className="currency-input">

                                        <span>$</span>

                                        <input
                                            id="customAmount"
                                            type="number"
                                            min="1"
                                            max="100000"
                                            step="0.01"
                                            value={
                                                customAmount
                                            }
                                            onChange={(e) =>
                                                setCustomAmount(
                                                    e.target.value
                                                )
                                            }
                                            placeholder="Enter amount"
                                        />

                                    </div>

                                </div>

                            )}


                            {/* NAME */}

                            <div className="form-section">

                                <label
                                    className="form-label"
                                    htmlFor="donorName"
                                >
                                    Name
                                </label>

                                <input
                                    id="donorName"
                                    type="text"
                                    value={name}
                                    onChange={(e) =>
                                        setName(
                                            e.target.value
                                        )
                                    }
                                    placeholder="Your name"
                                    disabled={anonymous}
                                />

                            </div>


                            {/* EMAIL */}

                            <div className="form-section">

                                <label
                                    className="form-label"
                                    htmlFor="donorEmail"
                                >
                                    Email
                                    <span className="required">
                                        *
                                    </span>
                                </label>

                                <input
                                    id="donorEmail"
                                    type="email"
                                    value={email}
                                    onChange={(e) =>
                                        setEmail(
                                            e.target.value
                                        )
                                    }
                                    placeholder="you@example.com"
                                    required
                                />

                                <div className="field-help">
                                    Your email is used to
                                    provide your donation
                                    receipt.
                                </div>

                            </div>


                            {/* MESSAGE */}

                            <div className="form-section">

                                <label
                                    className="form-label"
                                    htmlFor="donorMessage"
                                >
                                    Message
                                    <span className="optional">
                                        (optional)
                                    </span>
                                </label>

                                <textarea
                                    id="donorMessage"
                                    value={message}
                                    onChange={(e) =>
                                        setMessage(
                                            e.target.value
                                        )
                                    }
                                    placeholder="Leave a message..."
                                    rows="4"
                                />

                            </div>


                            {/* ANONYMOUS */}

                            <label className="anonymous-option">

                                <input
                                    type="checkbox"
                                    checked={anonymous}
                                    onChange={(e) =>
                                        setAnonymous(
                                            e.target.checked
                                        )
                                    }
                                />

                                <span>
                                    Make this donation anonymous
                                </span>

                            </label>


                            {/* ERROR */}

                            {error && (

                                <div className="donation-error">
                                    {error}
                                </div>

                            )}


                            {/* BUTTON */}

                            <button
                                type="submit"
                                className="donate-button"
                                disabled={loading}
                            >

                                {loading
                                    ? "Connecting to Stripe..."
                                    : `Donate $${getDonationAmount()
                                        ? getDonationAmount().toFixed(2)
                                        : "0.00"
                                    }`
                                }

                            </button>


                            <div className="secure-payment">

                                <span>
                                    🔒
                                </span>

                                <span>
                                    Secure payment powered by Stripe
                                </span>

                            </div>

                        </form>

                    </div>

                </div>

            </section>


            {/* =====================================================
                OTHER WAYS TO SUPPORT
            ====================================================== */}

            <section className="other-support">

                <div className="other-support-container">

                    <div className="donation-eyebrow">
                        MORE WAYS TO HELP
                    </div>

                    <h2>
                        Support STEMX365 Beyond a Donation
                    </h2>

                    <p>
                        Individuals, organizations, and companies
                        can support STEMX365 through sponsorship,
                        educational partnerships, equipment,
                        and major gifts.
                    </p>

                    <div className="support-buttons">

                        <a href="/rect/contact">
                            Contact STEMX365
                        </a>

                        {/* <a href="/rect/sponsor">
                            Become a Sponsor
                        </a> */}

                    </div>

                </div>

            </section>


            {/* =====================================================
                DISCLAIMER
            ====================================================== */}

            <section className="donation-disclaimer">

                <div>

                    <p>
                        STEMX365 is a U.S.-based nonprofit
                        organization. Donation receipts and
                        tax-deductibility information are subject
                        to the organization's applicable legal
                        and tax status.
                    </p>

                </div>

            </section>

        </main>
    );
};

export default Donation;